import React, {useEffect} from 'react';
import { NavLink } from 'react-router-dom';
import { animations, easings, HideUntilLoaded } from "react-animation";
import Image from "../../../assets/images/platforms/feeding/image.jpg";

const Feeding = () => {
  const anim1 = {
    animation: `pop-in ${easings.linear} 1000ms forwards`,
  };
  const anim2 = {
    animation: `pop-in ${easings.easeInOutQuad} 1000ms forwards`,
  };

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    return () => {};
  }, []);

  return (
    <div style={{ marginTop: "-80px" }}>
      <div className="container">
        <div className="platform-page-container">
          <div className="platform-page-inner">
            <div className="container">
              {" "}
              <img src={Image} alt="" className="p-image" />
            </div>{" "}
            <div className="">
              <p>
                The amazing feeding out of salary. You can order food of your
                choice from diffirent restaurants at any time and pay later.
              </p>
            </div>
            <div className="signup-btn-primary">
              <NavLink to="/sign-up">
                <button className="primary-btn">Get Started</button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Feeding